export default __webpack_public_path__ + "static/media/cliff-copy.119956aa.jpg";